<template>
  <section
    :id="element.Oid + '-element'"
    style="position: relative; z-index: 1000"
    :style="{
      width: `${element.startWidth*100}%`,
      left: `${100 * (1 + element.startWidth) * element.startPosition - 100 * element.startWidth}%`,
      opacity: `${element.startOpacity}`,
      transform: `scale(${element.startScale * scaleFactor})`,
      minHeight: '120px'
    }"
    v-observe-visibility="{
      callback: visibilityChanged,
      throttle: 300,
    }"
  >

    <div v-if="elementVisible" class="flex flex-col">
      <!-- images -->
      <div class="flex items-end justify-center">
        <div v-for="(imgSrc, idx) in images" :key="imgSrc" :style="{'margin-left' : idx > 0 ? '8%' : '0%'}">
          <!-- Hyperlinked images -->
          <a v-if="link" :href="link" target="_blank">
            <img :src="imgSrc" />
          </a>

          <!-- Naked images -->
          <img v-else :src="imgSrc" />
        </div>
      </div>

      <!-- Caption -->
      <div
        class="m-1 ql-editor"
        v-html="element.text"
      />
    </div>
    
  </section>
</template>

<script>
import { validURL } from '@/utils'

export default {
  components: {},

  props: {
    element: { type: Object, default: () => {} },
    scaleFactor: { type: Number, default: 1 },
  },

  data() {
    return {};
  },

  watch: {},

  methods: {
    visibilityChanged (isVisible) {
      if(this.element.isBackground) {
        if(isVisible) {
          this.$store.dispatch("narratives/setActiveBackground", this.element);
        } else {
          this.$store.dispatch("narratives/removeActiveBackground", this.element);
        }
      }
    },
  },

  computed: {
    link() {
      if(this.element.hyperlink && validURL(this.element.hyperlink)) {
        let url = this.element.hyperlink
        if(!url.includes('http')) {
          url = `http://${url}`
        }
        return url;
      }
      return ''
    },
    images() {
      return this.element.urls || []
    },
    elementVisible() {
      return !this.element.isBackground
    }
  },

  mounted() {
    
  },
};
</script>

<style></style>
